import ko from "knockout";
import ObservableModel from "util/ObservableModel";

const Contact = ObservableModel.extend(
    {
        defaults: {
            data: null,
        },
    },
    function () {
        const self = this;

        self.hasData = ko.computed(function () {
            return self.data() !== null;
        });
    }
);

export default Contact;
